import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {allPayrollsFetchState} from "../app/payroll/selectors";
import {fetchPayrolls} from "../app/payroll/actions";

export const useFetchPayrolls = () => {
    const dispatch = useDispatch()
    const fetchState = useSelector(allPayrollsFetchState)

    useEffect(() => {
        if (fetchState === 'idle') {
            dispatch(fetchPayrolls() as any)
        }
    }, [fetchState, dispatch])
}

export default useFetchPayrolls;
